import { observer } from 'mobx-react-lite';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_EventsStore } from './EventsStore';

export const EventsView = observer(function EventsView() {
  const store = useResolve(TOKEN_EventsStore);
  const fields: { label: string; value: string; on: (v: string) => void; testid: string }[] = [
    { label: 'subject', value: store.subject, on: (v) => store.setSubject(v), testid: 'events-subject' },
    { label: 'actor', value: store.actor, on: (v) => store.setActor(v), testid: 'events-actor' },
    { label: 'action', value: store.action, on: (v) => store.setAction(v), testid: 'events-action' },
    { label: 'client_id', value: store.clientId, on: (v) => store.setClientId(v), testid: 'events-client' },
  ];
  return (
    <div className="space-y-4" data-testid="events-screen">
      <form
        className="flex flex-wrap items-end gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-800"
        onSubmit={(e) => {
          e.preventDefault();
          void store.search();
        }}
      >
        {fields.map((f) => (
          <label key={f.testid} className="flex flex-col gap-1 text-xs text-slate-500">
            {f.label}
            <input
              value={f.value}
              onChange={(e) => f.on(e.target.value)}
              data-testid={f.testid}
              className="rounded border border-slate-300 px-2 py-1 text-sm text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
            />
          </label>
        ))}
        <button type="submit" disabled={store.loading} data-testid="events-search" className="rounded bg-indigo-600 px-3 py-1.5 text-sm text-white disabled:opacity-50">
          search
        </button>
      </form>

      {store.error && <p className="text-sm text-rose-600" data-testid="events-error">{store.error}</p>}
      {store.hasRun && store.events.length === 0 && !store.loading && <p className="text-sm text-slate-500">No events match.</p>}

      <ul className="divide-y divide-slate-200 rounded-lg border border-slate-200 text-sm dark:divide-slate-800 dark:border-slate-800" data-testid="events-list">
        {store.events.map((e, i) => (
          <li key={`${e.aggregate_id}-${i}`} className="grid grid-cols-[8rem_1fr] gap-2 px-3 py-2">
            <span className="font-mono text-xs text-slate-500">{new Date(e.ts).toISOString().slice(0, 19).replace('T', ' ')}</span>
            <span>
              <span className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-xs dark:bg-slate-800">{e.action}</span>{' '}
              <span className="text-slate-600 dark:text-slate-300">
                {e.actor ? `${e.actor} → ` : ''}
                {e.subject}
              </span>
              <code className="ml-2 text-xs text-slate-400">{JSON.stringify(e.details)}</code>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
});
